import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import "./CompanyDetail.css";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { useSelector, useDispatch } from "react-redux";
import * as Yup from "yup";
import { registeredCompany } from "../redux/slices/company/companySlice";
import axios from "axios";
import cookie from 'react-cookies'
import { baseURL } from "../axios/AxiosAut";

const validationSchema = Yup.object({
  company_name: Yup.string()
    .min(1, "Too short!")
    .max(30, "Too long!")
    .required("Company name is required"),
  company_description: Yup.string().max(100, "Too long!"),
  city: Yup.string().required("Required!"),
  state: Yup.string().required("Required!"),
  postal_code: Yup.string().required("Required!"),
  country: Yup.string().required("Required!"),
});

type ButtonProp = {
  HandleNext: () => void;
};

function CompanyDetails(props: ButtonProp) {
  const [SelectedFile, setSelectedFile] = useState<any>();
  const [isFilePicked, setIsFilePicked] = useState({});
  const userData = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch();
  console.log("company detail", userData.email);
  const initialValues = {
    company_name: "",
    company_description: "",
    city: "",
    state: "",
    postal_code: "",
    country: "",
    is_billing_billing_address: true,
    company_icon: "",
  };
 
  const onSubmit = (values, onSubmitProps) => {
    console.log("Form Data", values);
    axios.post(`${baseURL}company/company_create/`, values,{
    headers:{ Authorization: `Bearer ${cookie.load("access_token")}`}
     
    })
      .then((response) => {
        console.log("Company Api", response);
        dispatch(registeredCompany(response.data));
        props.HandleNext();
      })
      .catch((err) => {
        onSubmitProps.setSubmitting(false);
        console.log(err);
      });
            // onSubmitProps.setSubmitting(false);
            // props.HandleNext();

  };
  const handleFile = (event, props) => {
    const { form } = props;
    form.setFieldValue("company_icon", event.target.files[0]);
  };
  return (
    <>
      <div className="min-h-full flex items-center  justify-center sm:px-6 lg:px-8">
        <div className="max-w-3xl w-full space-y-8">
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            validateOnMount
          >
            <Form className="space-y-6">
              <div className="grid">
                <Field name="company_name">
                  {(props) => {
                    const { field, form, meta } = props;
                   
                    return (
                      <div className="mt-4">
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Company Name"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    );
                  }}
                </Field>
                <Field name="company_description">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <div className="mt-11">
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Description"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    );
                  }}
                </Field>
              </div>
              <div className="grid grid-cols-2 gap-10">
                <Field name="city">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <div className="my-6">
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="City"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    );
                  }}
                </Field>
                <Field name="state">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <div className="my-6">
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="State"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    );
                  }}
                </Field>
              </div>
              <div className="grid grid-cols-2 gap-10">
                <Field name="postal_code">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <div>
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Zip/Postal Code"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    );
                  }}
                </Field>
                <Field name="country">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <div>
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Country"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    );
                  }}
                </Field>
              </div>
              <Field name="is_billing_billing_address">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <div className="my-6">
                      <label className="text-gray-700">
                        <input type="checkbox" value="" />
                        <span className="ml-1">Billing Address</span>
                      </label>
                    </div>
                  );
                }}
              </Field>
              <Field name="company_icon">
                {(props) => {
                  const { field, form, meta } = props;
                  
                  return (
                    <>
                      <input
                        type="file"
                        accept="image/*"
                        id="company_icon"
                        style={{ display: "none" }}
                        onChange={(event) => {
                          handleFile(event, props);
                        }}
                      />
                      <div className="upload">
                        <label className="uploadicon" htmlFor="company_icon">
                          <AddCircleIcon color="primary" />
                          <h4 className="heading">Upload icon</h4>
                        </label>
                      </div>
                    </>
                  );
                }}
              </Field>
              <Field>
                {(props) => {
                  const { field, form, meta } = props;
                  const { isSubmitting } = form;
                  return (
                    <>
                      {!isSubmitting ? (
                        <button
                          type="submit"
                          {...(form.isValid
                            ? {
                                className:
                                  "font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow ",
                              }
                            : {
                                disabled: true,
                                className:
                                  "font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow opacity-50 cursor-not-allowed",
                              })}
                        >
                          Confirm
                        </button>
                      ) : (
                        <button
                          disabled
                          className="font-Montserrat font-semibold flex-shrink bg-blue-200 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow"
                        >
                          <div className="flex items-center justify-center space-x-2 animate-pulse">
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                          </div>
                        </button>
                      )}
                    </>
                  );
                }}
              </Field>
            </Form>
          </Formik>
        </div>
      </div>
    </>
  );
}

export default CompanyDetails;
